import reducer from '.';
import { createStore as reduxCreateStore } from "redux"
const createStore = (initialState) => reduxCreateStore(reducer, initialState)
export default createStore